import { getWeatherDomainType, getSvg } from "@/utils";
import { getPrivacyPolicyUrl } from "@/utils/copyright";
import { useTranslation } from "react-i18next";
export default function PrivacyAgreement({}) {
  const style01: any = {
    width: "16rem",
    display: "flex",
    textAlign: "center",
    fontSize: "10px",
    lineHeight: "0.7rem",
  };
  const style02: any = {
    margin: "0 auto",
    lineHeight: "16px",
  };
  const style03 = {
    textDecoration: "underline",
    color: "#fff",
  };
  const textStyle = {
    fontSize: "12px",
  };
  const { t: $t } = useTranslation();
  return (
    <div className="flex flex-col gap-y-20 mt-30 pb-100">
      <div className="color-[#fff] center gap-x-4">
        <div className="font-400 color-[rgba(255,255,255,0.52)]" style={textStyle}>
          {$t("title41")}
        </div>
        <div className="flex justify-start items-center">
          <img className="w-80 h-12" src={getSvg("logo.svg")} alt="" />
        </div>
        <div className="font-400 color-[rgba(255,255,255,0.52)]" style={textStyle}>
          {$t("title48")}
        </div>
      </div>
      <div className="flex flex-col color-[#fff] justify-start items-center m-[10px_0]">
        <div style={style01}>
          <p style={{ ...style02, ...textStyle }}>
            {getWeatherDomainType() === "24hweather.com" ? $t("title49") : $t("title38")}
          </p>
        </div>
        <div style={style01}>
          <p style={style02}>
            <a href={getPrivacyPolicyUrl()} target="_blank" style={{ ...textStyle, ...style03 }}>
              {$t("title39")}
            </a>
          </p>
        </div>
        <div style={style01}>
          <p style={{ ...textStyle, ...style02 }}>
            {getWeatherDomainType() === "24hweather.com" ? $t("title50") : $t("title40")}
          </p>
        </div>
      </div>
    </div>
  );
}
